const messages = {
  title: "Vaučeri",
  short_description:
    "Ovde možete pronaći vašu listu vaučera. Možete ih podeliti sa vašim klijentom. Vaučeri se koriste jednom.",
  table: {
    headers: {
      voucher: "Kodovi vaučera",
      company: "Kompanija",
      street: "Ulica",
      postcode: "Poštanski broj",
      location: "Lokacija",
      solved_at: "Datum",
      points: "Broj poena preko koda",
    },
  },
  exchange: {
    title: "Unesite vaš kod da dobijete poene",
    pointsLabel: "Unesite kod ovde:",
    result: "Broj poena:",
  },
};

export default {
  messages,
};
